import { vars } from '@dansk-metal/theme';
import { Button } from '@dansk-metal/ui';

import { usePagination } from './hooks/use-pagination';

import styles from './pagination.module.scss';

type PaginationProps = ReturnType<typeof usePagination> & {
	/* Allows href based pagination for SEO purposes */
	pageLink?: (page: number) => string;
};

export function Pagination({ nextPage, prevPage, maxPages, page, pageLink }: PaginationProps) {
	return (
		<>
			<div className={styles.pagination}>
				<div>
					<Button
						href={(pageLink && page !== 1) ? pageLink(page - 1) : undefined}
						onClick={(e: React.MouseEvent) => {
							e.preventDefault();
							prevPage();
						}}
						size="medium"
						variant="inline-thick"
						disabled={page === 1}
						icon={{ icon: 'arrow-left', position: 'before', color: vars['--color-secondary'] }}
					/>
				</div>
				<div className={styles.pagination__text}>
					<p>
						Side {page} af {maxPages}
					</p>
				</div>
				<div>
					<Button
						href={(pageLink && page !== maxPages) ? pageLink(page + 1) : undefined}
						onClick={(e: React.MouseEvent) => {
							e.preventDefault();
							nextPage();
						}}
						size="medium"
						variant="inline-thick"
						disabled={page === maxPages}
						icon={{ icon: 'arrow-right', position: 'after', color: vars['--color-secondary'] }}
					/>
				</div>
			</div>
		</>
	);
}

Pagination.usePagination = usePagination;
